/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_TitleInputs */

const vi_lot_items_title = /** @type {(inputs: Lot_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô trong phiếu`)
};

/**

* @param {Lot_Items_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_title = /** @type {((inputs?: Lot_Items_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_title(inputs)
});